(() => {
  angular
    .module('app.ics')
    .controller('InterceptionListController', InterceptionList);

  InterceptionList.$inject = [
    '$filter',
    'ModalService',
    'Interceptions',
  ];

  function InterceptionList(
    $filter,
    ModalService,
    Interceptions,
  ) {
    const vm = this;

    vm.loaded = false;

    vm.predicate = 'id';
    vm.orderDesc = false;

    vm.items = [];

    vm.sortBy = function (newPredicate) {
      if (vm.predicate == newPredicate) {
        vm.orderDesc = !vm.orderDesc;
      } else {
        vm.predicate = newPredicate;
        vm.orderDesc = false;
      }
      vm.items = $filter('orderBy')(vm.items, vm.predicate, vm.orderDesc);
    };

    Interceptions.list({id : window.ICS_CONFIG.accountId}, response => {
      vm.items = _.map(response.data, item => {
        var viewModel = {
          id : item.id,
          name : item.name,
          status : item.status,
          surveyUrl : item.surveyUrl,
          participantsCount : item.requiredStartsCount,
          dailyInvitationLimit: item.dailyInvitationLimit,
          accepts : item.accepts,
          progress : 0
        };

        viewModel.statusCode = "i";
        if (viewModel.status == 'Active')
          viewModel.statusCode = "a";
        if (viewModel.status == 'Finished')
          viewModel.statusCode = "f";

        if (viewModel.participantsCount){
          viewModel.progress = Math.round((viewModel.accepts / viewModel.participantsCount) * 100);
        }

        if (item.endAtUtc) {
          viewModel.endTime = item.endAtUtc;
        }

        viewModel.codesToShow = '';
        viewModel.firstCode = '';
        viewModel.showMoreCount = 0;

        var allCodes = JSON.parse(item.campaigns);
        var c = [];
        if (allCodes && allCodes.length > 0){
          _.each(allCodes, i => {
            var title = i.codeType == 1 ? i.name : i.code;
            c.push(title);
          });
          viewModel.allCodes = c.join(', ');
          viewModel.codesToShow = c[0];
          viewModel.showMoreCount = c.length - 1;
        }

        viewModel.showAllCodes = model => {
          model.showMoreCount = 0;
          model.codesToShow = model.allCodes;
        };

        return viewModel;
      });

      vm.items = $filter('orderBy')(vm.items, 'id', true);

      vm.loaded = true;
    });

    vm.startInterception = function(item) {
      Interceptions.start({id: item.id}, {}, function(response){});
      item.status = 'Active';
    };

    vm.stopInterception = function(item){
      Interceptions.stop({id: item.id}, {}, function(response){});
      item.status = 'Inactive';
    };

    vm.delete = function(item) {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/interception/modal/delete.html',
          controller: 'DeleteInterceptionController',
          controllerAs: 'dic',
          inputs: {
            interception: item,
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            if (result) {
              var index = _.indexOf(vm.items, result);
              if (index != -1){
                vm.items.splice(index, 1);
              }
            }
          });
        });
    }
  }
})();
